import { t } from "i18next";
import { Button } from "../ui/Button";
import CustomIcon from "../CustomIcon";
import AppModal from "../modals/AppModal";
import { ModalActions } from "../modals/layout";

export default function ConfirmModal({
  isVisible,
  onConfirm,
  onCancel,
  title,
  promptText,
  cancelText = t("Cancel"),
  confirmText = t("Yes"),
  confirmDanger = false,
}: {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  title?: string;
  promptText: string;
  cancelText?: string | null;
  confirmText?: string;
  confirmDanger?: boolean;
}) {
  return (
    <AppModal
      visible={isVisible}
      modalStyle={{
        width: "80%",
        padding: "32px 20px",
        backgroundColor: "white",
        gap: 16,
      }}
    >
      {onCancel && (
        <div className="flex justify-end">
          <CustomIcon
            iconName="close_alt"
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
          />
        </div>
      )}

      {title && (
        <span className="text-center text-2xl font-bold text-primary-black">
          {title}
        </span>
      )}
      <span className="text-center text-base font-medium text-[#6d6d6d]">
        {promptText}
      </span>

      <ModalActions style={{ flexDirection: "column" }}>
        <Button
          variant={confirmDanger ? "destructive" : "accent"}
          size="lg"
          className="w-full"
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          {confirmText}
        </Button>
        {!!cancelText && (
          <Button
            variant="outline"
            size="lg"
            className="w-full"
            onClick={(e) => {
              e.preventDefault();
              onCancel && onCancel();
            }}
          >
            {cancelText}
          </Button>
        )}
      </ModalActions>
    </AppModal>
  );
}
